import { schema } from 'normalizr';

const IDENTIFICATOR_SCHEMA = new schema.Entity('identificators', {}, { idAttribute: '@id' });

export default {
  File: IDENTIFICATOR_SCHEMA
};
